import { Component, OnInit } from '@angular/core';
import { UserProfileService } from '@app/gateway/user-profile/user-profile.service';
import { ApiService } from '@app/gateway/services/api.service';
import { HttpHeaders } from '@angular/common/http';
import { TokenService } from '@app/services/token/token.service';
import { ServiceConfigService } from '@app/services/service-config.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { ModalService } from '@app/services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { GoogleAnalyticsService } from '@app/services/analytics/analytics.service';

@Component({
  selector: 'nh-ridp-documents',
  templateUrl: './ridp-documents.component.html',
  styleUrls: ['./ridp-documents.component.scss'],
  standalone: false
})
export class RidpDocumentsComponent implements OnInit {
  memberInfo: any = {};
  defaultLanguage;
  translatedLang;
  submittedDocuments: any[] = [];
  verificationStatusOptions = [];
  verificationStatus = null;
  documentTypes: any[] = [];
  ridpUserDetailsResp = {}
  displaySuccessBanner = false;
  isVerificationDisabled = false;
  tcamId;
  mobileAppRidpUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  url;
  payLoad = {};
  validSession = false;
  fromWp = null;
  reviewDocs = null;
  notVerified = sessionStorage.getItem('ridpNotVerified') === 'true';
  keproUrl;
  allAreErrorDocs = false;
  workerNotes: string = '';
  ridpReadOnly: string;
  supportingDocTypes: any[] = [];

  constructor(private userProfileService: UserProfileService,public apiService: ApiService, 
    private token: TokenService,  private serverConfig: ServiceConfigService,  private modalService: ModalService,
    private route: ActivatedRoute, private authService: AuthService, protected router: Router,  public translateService: TranslateService,public analytics: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.tcamId = this.serverConfig.getServerConfig().TCAM_KEY;
    this.keproUrl = this.serverConfig.getServerConfig().keprolUrl;
    const params = this.route.snapshot.queryParams
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
    this.translatedLang = res?.lang;
    if(this.ridpUserDetailsResp && Object.keys(this.ridpUserDetailsResp).length > 0){
      this.getTableData(this.ridpUserDetailsResp);
    }
    });
    
    // Load document types once
    const docTypeUrl = `publ/reference-tables/retrieve?table=RIDPDOCINFO`;
    this.apiService.get(docTypeUrl, null, { headers: new HttpHeaders({ 'pageId': 'RIDPD', 'sessionId': this.token.getSessionId() }) }).subscribe((res:any) => {
      this.documentTypes = res['columnDetails'] || [];
    });

    const url = `publ/reference-tables/retrieve?table=RIDPSUPPORTINGDOCINFO`;
    this.apiService.get(url, null, { headers: new HttpHeaders({ 'pageId': 'RIDPD', 'sessionId': this.token.getSessionId() }) }).subscribe((res: any) => {
      this.supportingDocTypes = res?.['columnDetails'] || [];
    });
    const ahsMpToken = sessionStorage.getItem('AhsMpToken');

    if (Object.keys(params).length > 0 || ahsMpToken) { //logic for AHS users for both valid and invalid sessions
      if(!ahsMpToken) {
        sessionStorage.setItem('isAhsRidp', 'true');
      this.route.queryParams.subscribe((response: any) => {
        if (response?.mpToken) {
          this.apiService.setAhsMpToken(response?.mpToken);
          this.url = `publ/users/KeyProLogin`;
          this.payLoad = { tcam: this.token.getCookie(this.tcamId), mpToken: response?.mpToken, source: null };
          this.apiService.removeQueryParam('mpToken');
        }
      }) 
      } else {
        this.apiService.setAhsMpToken(ahsMpToken);
        this.url = `publ/users/KeyProLogin`;
        if (ahsMpToken) {
        const decodedToken = decodeURIComponent(ahsMpToken)
        this.payLoad = { tcam: this.token.getCookie(this.tcamId), mpToken: decodedToken, source: null };
        }
      } 

      // need to confirm page id
      const backToPartnerSite = () => window.location.href = this.keproUrl;
      const contentHeader = new HttpHeaders({ "Content-Type": "application/json", pageId: 'TCKPR', 'sessionId': this.token.getSessionId() });
      this.apiService.post(this.url, this.payLoad, { headers: contentHeader, observe: 'response' }).subscribe((response: any) => {
        if (response && response.body?.isValidSession === 'true') {
          const authToken = response.headers.get('x-auth-token');
          sessionStorage.setItem('userType', response.body?.userType);
          sessionStorage.setItem('mpUserName', response.body?.mpUserName);
          const mpUserName = sessionStorage.getItem('mpUserName');
          let batchNum = response.body?.batchNum;
          // Format batch number - remove TCC_ prefix if it exists
          if (batchNum && batchNum.startsWith('TCC_')) {
            batchNum = batchNum.replace('TCC_', '');
          }
          sessionStorage.setItem('batchNum', batchNum);
          //const taskStatus = response.body?.taskStatus;
          // console.log('RIDP Task Status:', taskStatus);
          sessionStorage.setItem('userName', response.body?.userName);
          sessionStorage.setItem('individualId', response.body?.indvId);
          sessionStorage.setItem('encryptedIndvId', response.body?.encryptedIndvId);
          this.analytics.setCurrentUser(response.body?.userName);
          this.authService.setToken(authToken);
          this.validSession = true;
          this.fromWp = true
          this.ridpReadOnly = response && response?.body?.authorized;
          // Get RIDP user details
          this.apiService.get(`indi/users/getRidpUserDetails?userId=${mpUserName}&batchNum=${batchNum}`, null, {
            headers: new HttpHeaders({ 'pageId': 'RIDPAHS', 'sessionId': this.token.getSessionId() })
          }).subscribe((res) => {
            this.ridpUserDetailsResp = res;
             this.getTableData(res);
            const url = `publ/reference-tables/retrieve?table=RIDPDOCSTATUS`;
            this.apiService.get(url, null, { headers: new HttpHeaders({ 'pageId': 'TCHPD', 'sessionId': this.token.getSessionId() }) }).subscribe((resp) => {
              this.verificationStatusOptions = [...resp['columnDetails']];
              // Disable form for unauthorized users (authorized = 'N')
              if (this.ridpReadOnly === 'N') {
                this.isVerificationDisabled = true;
              }
              // Pre-select the first option or find the matching option by code
              if (this.verificationStatusOptions.length > 0 && this.ridpUserDetailsResp['documents']?.[0]['ridpStatusCd'] !== 'IP') {
                if(this.ridpUserDetailsResp['documents']?.[0]['ridpStatusCd'] === 'ERR'){
                  this.verificationStatus = this.verificationStatusOptions.find(opt => opt.code === 'NV');
                  this.workerNotes = this.ridpUserDetailsResp['documents']?.[0]['ridpWorkerVerificationNotes'] || '';
                } else {
                  this.verificationStatus = this.verificationStatusOptions.find(opt => opt.code === 'VF');
                }
                // Disable dropdown and submit button if verificationStatus is already set
                  this.isVerificationDisabled = true;
              }
            });
          });
        } else {
          backToPartnerSite();
        }
      })
    } else {
      this.fromWp = false;
    }

      if(sessionStorage.getItem('ridpReviewDocs') === 'true'){
        this.reviewDocs = true;
         const userId = sessionStorage.getItem('userName');
          this.apiService.get(`indi/users/getRidpUserDetails?userId=${userId}`, null, {
            headers: new HttpHeaders({ 'pageId': 'RIDPAHS', 'sessionId': this.token.getSessionId() })
          }).subscribe((res) => {
            this.ridpUserDetailsResp = res;
           this.getTableData(res);
          })
      } else {
        this.reviewDocs = false;
      }
  }

    getFullName(res) {
    if (res) {
      let fullName;
      const middleName = res?.middleName
      if (middleName) {
        fullName = res?.firstName + ' ' + res?.middleName + ' ' + res?.lastName;
      } else {
        fullName = res?.firstName + ' ' + res?.lastName;
      }
      return fullName
    }
  }

  formatPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return phoneNumber;
    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, '');
    // Format as XXX-XXX-XXXX
    if (cleaned.length === 10) {
      return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    }
    return phoneNumber; // Return original if not 10 digits
  }

  formatSSN(ssn: string): string {
    if (!ssn) return ssn;
    // Remove all non-numeric characters
    const cleaned = ssn.replace(/\D/g, '');
    // Format as XXX-XX-#### (mask first 5 digits, show last 4)
    if (cleaned.length === 9) {
      return `XXX-XX-${cleaned.substring(5)}`;
    }
    return ssn; // Return original if not 9 digits
  }

  getCountyName(code, countyData) {
    const county = countyData?.find(opt => opt.code === code);
    return this.translatedLang === 'en' ? county?.enDescription : county?.spDescription;
  }
  
    private formatDateArray(dateObj: any): string {
    if (!dateObj) {
      return '';
    }
    
    // Handle object format: {year, monthValue, dayOfMonth, ...}
    if (typeof dateObj === 'object' && !Array.isArray(dateObj)) {
      const year = dateObj.year;
      const month = dateObj.monthValue;
      const day = dateObj.dayOfMonth;
      
      if (!year || !month || !day) {
        return '';
      }
      
      const monthStr = month.toString().padStart(2, '0');
      const dayStr = day.toString().padStart(2, '0');
      return `${monthStr}/${dayStr}/${year}`;
    }
    
    // Handle array format: [year, month, day] (legacy support)
    if (Array.isArray(dateObj) && dateObj.length === 3) {
      const [year, month, day] = dateObj;
      const monthStr = month.toString().padStart(2, '0');
      const dayStr = day.toString().padStart(2, '0');
      return `${monthStr}/${dayStr}/${year}`;
    }
    
    return '';
  }

  getTableData(res) {
    // Load county data first
    const url = `publ/reference-tables/retrieve?table=COUNTY`;
    this.apiService.get(url, null, { headers: new HttpHeaders({ 'pageId': 'TCHPD', 'sessionId': this.token.getSessionId() }) }).subscribe((resp) => {
      const countyData = resp['columnDetails'];

      this.memberInfo = {
        firstName: res?.firstName,
        lastName: res?.lastName,
        middleName: res?.middleName,
        suffix: res?.suffixName,
        dob: this.formatDateArray(res.dobDt),
        ssn: this.formatSSN(res?.ssnNum),
        addressLine1: res?.addrLine1,
        addressLine2: res?.addrLine2,
        city: res?.cityAddr,
        state: res?.stateCd,
        zipCode: res?.zipCd,
        zipCodeExtension: res?.zipCdExt,
        county: res?.addrCountyCd !== 'US' ? this.getCountyName(res?.addrCountyCd, countyData) : null,
        primaryPhone: this.formatPhoneNumber(res?.phnNum),
        emailAddress: res?.emailAddr,
        memberConsent: res?.memberConsentSw ? 'Yes' : 'No',
        language: res?.language
      }

      this.submittedDocuments = res?.documents.map(data => ({
        name: this.getFullName(res),
        documentType: this.getDocumentType(data.documentTypeCd),
        uploadDate: data.updatedLastTs,
        status: data.ridpStatusCd === 'IP' ? this.translatedLang === 'en' ? 'Pending Review' : 'Aún no se ha revisado' : data.ridpStatusCd === 'ERR' ? this.translatedLang === 'en' ? 'Not Verified' : 'No verificada' : this.fromWp && data.ridpStatusCd === 'VR' ? 'Verified' : null,
        statusCd:  data.ridpStatusCd,
        filenetId: data.fnDocumentId,
        pageCount: data.pageCount
      }))
      this.allAreErrorDocs = this.allDocumentsAreError();
    });
  }

  getDocumentType(code: string): string {
    const docType = this.documentTypes.find(opt => opt?.code === code);
    if (docType) {
      return this.translatedLang === 'en' ? docType.enDescription : docType.spDescription;
    } else {
      const supportingDocType = this.supportingDocTypes?.find(opt => opt?.code === code);
      if (supportingDocType) {
        return this.translatedLang === 'en' ? supportingDocType.enDescription : supportingDocType.spDescription;
      }
    }
    return code; // Return code if not found
  }

  onViewPdf(pdfId){
    this.userProfileService.getPrintDoc(pdfId, 'RIDPUD').subscribe((res: any) => {
      const file = new Blob([res], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      let w = window.open(fileURL);
      w.onload = () => {
				setTimeout(() => {	w.document.title = 'View Document'}, 500);
			};
    })
  }

  onSubmit(){    
    const userId = sessionStorage.getItem('userName');
    const mpuserId = sessionStorage.getItem('mpUserName');
    const batchNum = sessionStorage.getItem('batchNum');
    const payload = {
      usrId: mpuserId,
      partnerUser: userId,
      verificationStatus: this.verificationStatus?.enDescription,
      emailAddr: this.memberInfo?.emailAddress,
      phnNum: this.memberInfo?.primaryPhone,
      language: this.memberInfo?.language,
      ridpWorkerVerificationNotes: this.verificationStatus?.code === 'NV' ? this.workerNotes : null,
      batchNum: batchNum
    };
    
    this.apiService.post('indi/users/ridp/updateRidpVerification', payload, {
      headers: new HttpHeaders({ 'pageId': 'RIDPAHS', 'sessionId': this.token.getSessionId() })
    }).subscribe((res: any) => {
      if (res && res?.code === '200' && res?.message === 'Success') {
        this.displaySuccessBanner = true;
        this.isVerificationDisabled = true;
        setTimeout(() => {
          const container = document.querySelector('.mat-sidenav-content') as HTMLElement;
          if (container) {
            container.scrollTop = 0;
          }
          window.scrollTo(0, 0);
        }, 100)
      } else {
        this.displaySuccessBanner = false;
      }
    }, (error) => {
      console.error('Update RIDP Verification Error:', error);
      this.displaySuccessBanner = false;
    });
  }

  onGoToDashboard(): void {
    this.router.navigate(['/user-profile', 'benefit-dashboard']);
  }

  onUploadDocuments(from): void {
    sessionStorage.setItem('ridpUploadDocsFrom', from);
    this.router.navigate(['/verify-identity/uploadDocuments/upload-documents']);
  }

    showDocTypes(): void {
    this.modalService.openDocTypes();
  }

  allDocumentsAreError(): boolean {
    return this.submittedDocuments.length > 0 && this.submittedDocuments.every(doc => doc.statusCd === 'ERR');
  }

  isSubmitDisabled(): boolean {
    if (!this.verificationStatus || this.isVerificationDisabled) {
      return true;
    }
    // If "Not Verified" is selected, require the note
    if (this.verificationStatus?.code === 'NV' && !this.workerNotes?.trim()) {
      return true;
    }
    return false;
  }

  getSupportingPaystubOverride(): string | null {
    const languageCode = sessionStorage.getItem('globalTranslatedLan')?.toLowerCase();

    if (languageCode === 'zh') {
      return '工资单';
    }
    if (languageCode === 'vi') {
      return 'Phiếu lương';
    }
    if (languageCode === 'tl') {
      return 'Resibo ng sahod';
    }
    if (languageCode === 'ar') {
      return 'كشف الراتب';
    }

    return null;
  }

  onInput(event: Event) {
    const input = event.target as HTMLTextAreaElement;
    const cursorPosition = input.selectionStart;
    const value = input.value;
    const filteredValue = this.removeEmojis(value);
    // Update the textarea value without emojis
    input.value = filteredValue;
    // Restore the cursor position
    input.setSelectionRange(cursorPosition, cursorPosition);
    // Update the model
    this.workerNotes = filteredValue;
  }

  removeEmojis(value: string) {
    const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF]|[\r]|[^a-zA-Z0-9\n\\\\s~`! @#$%^&*()_|'"\-+={}\[\]:;"',.?/])/g;
    return value.replace(emojiRegex, '');
  }
}
